module.exports = __webpack_public_path__ + "../../../static/img/se_02.96b3e2e1.png";